import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";
import { generateEncryptedToken } from "../utils/crypto";
import { setAuthToken } from "../utils/auth";
import { apiPost } from "../utils/api";

export default function Login() {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        username: "",
        password: "",
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const encryptedToken = generateEncryptedToken();
            console.log("Encrypted Token:", encryptedToken);

            // Final payload for API
            const payload = {
                UserId: form.username,
                Password: form.password,
                Token: encryptedToken
            };
            console.log("Sending Payload:", payload);
            const data = await apiPost("/msg/Login", payload);
            console.log("API Response:", data);

            if (data.token) {
                //alert(data.token);
                // ✅ Store encrypted token in sessionStorage
                setAuthToken(data.token);

                // Optional: store username
                sessionStorage.setItem("username", form.username);
                sessionStorage.setItem("wano", data.wano);

                // Fetch balance after successful login
                try {
                    const balancePayload = {
                        UserId: form.username,
                        WANO: data.wano
                    };
                    const balanceData = await apiPost("/customers/GetUserBalance", balancePayload);
                    if (balanceData.balance !== undefined) {
                        sessionStorage.setItem("balance", String(balanceData.balance));
                        console.log("Balance fetched:", balanceData.balance);
                        try {
                            window.dispatchEvent(new CustomEvent("balanceUpdated", { detail: balanceData.balance }));
                        } catch (e) {
                            console.warn("Could not dispatch balanceUpdated event", e);
                        }
                    }
                } catch (balanceError) {
                    console.error("Failed to fetch balance:", balanceError);
                    // Continue with login even if balance fetch fails
                }

                //navigate("/send-message");
                navigate("/dashboard");
            } else {
                alert(data.message || "Invalid login!");
            }
        } catch (error) {
            console.error("Login Error:", error);
            alert("Login failed! Please try again.");
        }
    };

    return (
        <div className="page-container login-page">
            <div className="card login-card">
                <img
                    src="/logo.png"
                    alt="Product Logo"
                    style={{ width: "250px", maxWidth: "80%", marginBottom: "20px" }}
                />

                <div style={{ fontSize: "18px", color: "#2e7d32", marginBottom: "30px", lineHeight: "1.4" }}>
                    OmniChat: Connect across WhatsApp, Telegram, Instagram & Messenger instantly
                </div>

                <form onSubmit={handleLogin}>
                    <input
                        type="text"
                        name="username"
                        className="input-field"
                        placeholder="Username"
                        value={form.username}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="password"
                        name="password"
                        className="input-field"
                        placeholder="Password"
                        value={form.password}
                        onChange={handleChange}
                        required
                    />

                    <div style={{ textAlign: "right", marginBottom: "20px" }}>
                        <a href="#" style={{ fontSize: "13px", color: "#2e7d32", textDecoration: "none" }}>
                            Forgot Password?
                        </a>
                    </div>

                    <button type="submit" className="button">
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
}
